import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { GET_DUR_ALLERGIES } from 'gql'
import type { FuzzySearchProps } from 'modals/DurInputMappingsModal/types'
import type { DURSubject } from 'types'
import FuzzySearchAutoComplete from './FuzzySearchAutocomplete'

const AllergiesFuzzySearch = (props: FuzzySearchProps) => {
  const { searchTerm } = props
  const [newSearchTerm, setNewSearchTerm] = useState(searchTerm)
  const { data, error } = useQuery<{ getAllergies: DURSubject[] }>(GET_DUR_ALLERGIES, {
    skip: !newSearchTerm,
    variables: { knownAllergies: newSearchTerm },
  })

  useEffect(() => {
    setNewSearchTerm(searchTerm)
  }, [searchTerm])

  return (
    <FuzzySearchAutoComplete
      {...props}
      suggestions={data?.getAllergies ?? []}
      error={error}
      searchTerm={newSearchTerm}
      onChange={setNewSearchTerm}
    />
  )
}

export default AllergiesFuzzySearch
